<div class="container-title {{class}}">
    <svg *ngIf="dataConfig.icon">
        <use  attr.xlink:href="assets/svg/icons.svg#{{dataConfig.icon}}"/> 
     </svg>
    <h4>{{dataConfig.title}}</h4>
</div>